import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface SideDrawerState<T> {
  opened: boolean;
  data?: T;
}

@Injectable({ providedIn: 'root' })
export class DrawerService<T> {
  private state$ = new BehaviorSubject<SideDrawerState<T>>({
    opened: false,
  });
  currentlySelectedId!: string;
  readonly drawerState$ = this.state$.asObservable();

  open(data?: T) {
    this.state$.next({ opened: true, data });
  }

  close() {
    this.currentlySelectedId = '';
    this.state$.next({ opened: false });
  }
}
